import React, {useEffect, useState} from "react"
import {Col, Row} from "react-bootstrap";
import GratitudeCard from "../../../components/dashboard/cards/gratitude-card/GratitudeCard";
import dayjs from "dayjs";
import ThemeModals from "../../../components/common/modals/theme-modals/ThemeModals";
import "./gratitude-listing.scss"
import {GratitudeService} from "../../../services/gratitude-api.service";
import GratitudeViewSkeleton from "../../skeletons/home/GratitudeViewSkeleton";
import AddGratitude from "../home/gratitude/AddGratitude";
import Heading from "../../../components/dashboard/heading-component/Heading";
import {AiOutlinePlus} from "react-icons/ai";


export default function GratitudeListing() {
    const [addGratitude ,setAddGratitude] = useState(false);
    const [gratitudeData, setGratitudeData] = useState([])
    const [getListing, setGetListing] = useState(false)
    const [loader, setLoader] = useState(true)

    async function GetGratitudeData() {
        setLoader(true)
        const response = await GratitudeService.getGratitude();
        if(response?.data?.data?.status){
            setGratitudeData(response.data?.data?.data?.result)
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetGratitudeData()
    },[getListing])

    if (loader) {
        return <GratitudeViewSkeleton/>
    }

    return(
        <div className={'gratitude gratitude-listing'}>
            <div className={'gratitude-sub-heading-sec'}>
                <Heading heading={'My Gratitude'} back={true}/>
                <p><small className={'d-none d-md-flex'}>{gratitudeData.length} Gratitude Written </small> <span onClick={()=>{setAddGratitude(true)}}><AiOutlinePlus /></span></p>
            </div>
            <Row>
                {
                    gratitudeData.map((item,index)=>{
                        return(
                            <Col className={'mb-4'} sm={12} md={6} xl={6} xxl={4} key={index}>
                                <GratitudeCard getListing={getListing} setGetListing={setGetListing} heading={item.content[0].label} id={item._id} des={item.content[0].text} date={dayjs(item.createdAt).format('DD-MM-YYYY')}/>
                            </Col>
                        )
                    })
                }
            </Row>
            <ThemeModals
                open={addGratitude}
                close={setAddGratitude}
                title={'Write 3 things that you are grateful for?'}
                content={<AddGratitude close={setAddGratitude} getListing={getListing} setGetListing={setGetListing}/>}
            />
        </div>
    )
}